<template>
  <QualityRawMeasurementTable
    :is-detailed="true"
    :measurements="rawmaterial.measurements"
    :rawid="parseInt(rawmaterial.id)"
    :raw-title="rawmaterial.barcode + ' ' + rawmaterial.name"
    :loading="loading"
  >
  </QualityRawMeasurementTable>
</template>

<script>
import QualityRawMeasurementTable from "./QualityRawMeasurementTable";
import RawMaterial from "../../models/RawMaterial";
export default {
  name: "QualityRawMeasurementWrapper",
  components: { QualityRawMeasurementTable },
  props: {
    rawid: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      loading: true
    };
  },
  mounted() {
    this.initialize();
  },
  computed: {
    rawmaterial() {
      return RawMaterial.query()
        .with("measurements.rawmaterial")
        .find(parseInt(this.rawid));
    }
  },
  methods: {
    initialize() {
      this.loading = true;
      RawMaterial
        .$get(this.rawid)
        .then(() => this.loading = false)
    }
  }
};
</script>
